import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./slices/authSlice";
import userSlice from "./slices/userSlice";
import payStackSlice from "./slices/payStackSlice";
import supportRequestSlice from "./slices/supportRequestSlice";
import supportEmailConfig from "./slices/supportEmailConfigSlice";
import analyticsSlice from "./slices/analyticsSlice";
import paymentSlice from "./slices/paymentSlice";
import propertySlice from "./slices/propertySlice";


const store = configureStore({
  reducer: {
    auth: authSlice,
    user: userSlice,
    payStack: payStackSlice,
    supportRequest: supportRequestSlice,
    supportEmailConfig: supportEmailConfig,
    analytics: analyticsSlice,
    payment: paymentSlice,
    property: propertySlice,
  },
});

export default store;

// INFO: Exporting auth actions and thunks
export {
  logout,
  switchRole,
  checkAndSwitchRoleByPath,
  openSignInModal, 
  closeSignInModal,
  handleSessionExpiration,
  endDataRefresh,
  startDataRefresh,
  updateAuth,
} from "./slices/authSlice";

export * from "./thunks/authThunks";
export * from "./thunks/userThunks";
export * from "./thunks/payStackThunks";
export * from "./thunks/supportRequestThunks";
export * from "./thunks/supportEmailconfigThunks";
export * from "./thunks/analyticsThunks";
export * from "./thunks/paymentThunks"
export * from "./thunks/propertyThunks"
